(() => {
  if (customElements.get('primo-app-launch')) return;
  class PrimoAppLaunch extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const banner = this.querySelector('.primo-launch-bar');
      const announcement = document.querySelector('.announcement-bar-section');
      const updateHeaderSpacing = () => {
        if (banner) document.body.style.setProperty('--primo-launch-bar-height', `${banner.getBoundingClientRect().height}px`);
        if (announcement) document.body.style.setProperty('--primo-launch-announcement-height', `${announcement.getBoundingClientRect().height}px`);
      };
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(updateHeaderSpacing);
      if (banner) this.resizeObserver.observe(banner);
      if (announcement) this.resizeObserver.observe(announcement);
      updateHeaderSpacing();
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-primo-launch-open]');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.key = 'primo-app-launch-2026-v1';
      this.dataset.device = /iPhone|iPod/i.test(navigator.userAgent) ? 'iphone' : /Android/i.test(navigator.userAgent) ? 'android' : 'desktop';
      this.opener.addEventListener('click', (event) => {
        event.preventDefault();
        this.openPanel('banner');
      }, options);
      this.querySelectorAll('[data-primo-launch-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.remember();
        document.body.style.overflow = this.previousOverflow ?? '';
        this.previousFocus?.focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-primo-launch-download]').addEventListener('click', () => this.remember(), options);

    }
    disconnectedCallback() {
      this.cancelAuto();
      this.resizeObserver?.disconnect();
      document.body.style.removeProperty('--primo-launch-bar-height');
      document.body.style.removeProperty('--primo-launch-announcement-height');
      this.controller?.abort();
      if (this.dialog?.open) document.body.style.overflow = this.previousOverflow ?? '';
    }
    cancelAuto() {
      clearTimeout(this.timer);
      this.autoCancelled = true;
    }
    hasDismissed() {
      try {
        return Number(localStorage.getItem(this.key)) > Date.now() || sessionStorage.getItem(this.key) === 'seen';
      } catch { return false; }
    }
    remember() {
      try { sessionStorage.setItem(this.key, 'seen'); } catch {}
      try { localStorage.setItem(this.key, String(Date.now() + Number(this.dataset.days || 7) * 86400000)); } catch {}
    }
    openPanel(source) {
      if (this.dialog.open) return;
      this.cancelAuto();
      this.previousFocus = document.activeElement;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow = 'hidden';
      this.remember();
      this.dispatchEvent(new CustomEvent('primo:app-launch-open', { bubbles: true, detail: { source } }));
    }
  }
  customElements.define('primo-app-launch', PrimoAppLaunch);
})();
